import { formatIsoDate } from '@src/shell/utils/Formatter'
import { addDays } from 'date-fns'

export const getStartDate = () => formatIsoDate(addDays(new Date(), -90))
